import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'onboarding-header',
    templateUrl: './onboarding-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OnboardingHeaderComponent {
   @Input() step: { id: string, index: number };
   constructor() {}
}